import { render, staticRenderFns } from "./FormDiscountLocationsPopup.vue?vue&type=template&id=a428413e"
import script from "./FormDiscountLocationsPopup.vue?vue&type=script&lang=js"
export * from "./FormDiscountLocationsPopup.vue?vue&type=script&lang=js"
import style0 from "./FormDiscountLocationsPopup.vue?vue&type=style&index=0&id=a428413e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports